import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  FAILED_LOGIN_NOT_BEFORE_PERMANENT_THRESHOLD_SEC,
  formatCountdownFromSeconds,
  unlockCountdownEndEpochSec,
} from '../bruteForceStatusUi';

export default function BlacklistUnlockCountdown({ entry }) {
  const [, setTick] = useState(0);
  const endSec = unlockCountdownEndEpochSec(entry);

  useEffect(() => {
    if (endSec == null) {
      return undefined;
    }
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(id);
  }, [endSec]);

  if (!entry.userEnabled) {
    return '—';
  }
  if (
    (entry.failedLoginNotBeforeSeconds || 0) >
    FAILED_LOGIN_NOT_BEFORE_PERMANENT_THRESHOLD_SEC
  ) {
    return '—';
  }

  if (endSec != null) {
    const left = endSec - Math.floor(Date.now() / 1000);
    if (left <= 0) {
      return 'Unlocked';
    }
    return formatCountdownFromSeconds(left);
  }

  if (entry.bruteForceDisabled) {
    return '—';
  }

  return '—';
}

BlacklistUnlockCountdown.propTypes = {
  entry: PropTypes.object.isRequired,
};
